import React, { useState } from "react";
import "./MainPageHeaderDesktop.scss";
import { Nav, Navbar } from "react-bootstrap";
// imports Image
import MenuIcon from "assets/images/Menu.svg";
import BrandLogo from "assets/images/Logo.png";
import { useTypedSelector } from "store";
import BurgerMenu from "common/components/BurgerMenu";
import { useNavigate } from "react-router-dom";
import { MainPageHeaderProps } from ".";
import { formatDate } from "../../../utils/formatDate";

function MainPageHeaderDesktop({
  style,
  isPricingButtonHidden,
  isReloadLogo
}: MainPageHeaderProps) {
  const { client }: any = useTypedSelector((store) => store.user);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <header className="main-page-header" style={style}>
        <div className="logo-menu-icon-wrapper" style={{ flex: 1 }}>
          <a onClick={() => setIsOpen(!isOpen)}>
            <img src={MenuIcon} alt="" />
          </a>
          <Navbar.Brand
            onClick={() => (isReloadLogo ? location.reload() : navigate("/main_page"))}
            style={{ cursor: "pointer" }}>
            <img src={BrandLogo} alt="" style={{ width: 192, height: 47 }} />
          </Navbar.Brand>
        </div>
        <div className="nav-action-main-header">
          <Nav className="navbar-main-header">
            <Nav.Link href="#action1" className="nav-item">
              שלום,
              <strong>
                {" "}
                {client.firstName} {client.lastName}
              </strong>
            </Nav.Link>
            <Nav.Link href="#action1" className="nav-item">
              סוג מנוי:{" "}
              <strong>{client.subscriptionValid ? client.subscriptionType : "מוגבל בתוכן"}</strong>
            </Nav.Link>
            {client.subscriptionValid && !!client.dateExpirde && (
              <Nav.Link href="#action1" className="nav-item">
                תאריך תפוגה:
                <strong>{formatDate(client.expired)}</strong>
              </Nav.Link>
            )}
            {client.subscriptionValid && !!client.dateExpirde && (
              <Nav.Link href="#action1" className="nav-item">
                ימים שנשארו:
                <strong> {client.daysLeft}</strong>
              </Nav.Link>
            )}
          </Nav>
        </div>
        <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
          <button
            className="btn-md btn-md-primary"
            style={{ opacity: isPricingButtonHidden ? 0 : 1 }}
            onClick={() => navigate("/payment")}>
            לרכישת מנוי
          </button>
        </div>
      </header>
      <BurgerMenu viewOpenLeftMenu={isOpen} handleClickCloseLeftMenu={() => setIsOpen(false)} />
    </>
  );
}

export default MainPageHeaderDesktop;
